import { selectDriverFace,updateDriverFace } from "../../api/config/modules/DriverFaceFile";

const state = {
    selectDriverFace: {},
    updateDriverFace: {},
};

const mutations = {
    SET_SELECTDRIVERFACE: (state, selectDriverFace) => {
        state.selectDriverFace = selectDriverFace;
    },
    SET_UPDATEDRIVERFACE: (state, updateDriverFace) => {
        state.updateDriverFace = updateDriverFace;
    },
};

const actions = {
    GET_SELECTDRIVERFACE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectDriverFace(data)
                .then((res) => {
                    commit("SET_SELECTDRIVERFACE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATEDRIVERFACE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateDriverFace(data)
                .then((res) => {
                    commit("SET_UPDATEDRIVERFACE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
